
// FILE: src/controller/RatingController.js
function RatingController($scope) {
    
    const isDevEnvironment = false;
    const widget = $scope.widget;

    
    this.initializeValues = () => {
        widget.values = {
            stars: 0,
            observation: ''
        };
    };

    this.selectStar = (value) => {
        if (!widget.readOnly) {
            widget.values.stars = value;
        }
    };

    widget.selectStar = (value) => {
        widget.values.stars = value;
    };

    this.getStarImage = (value) => {
        const imageRoot = isDevEnvironment ? '../../dist/img' : './bower_components/odh-rating/dist/img';
        
        let starSrc;
        if (widget.readOnly) {
            starSrc = _isStarSelected(value) ? `${imageRoot}/star-readonly.png` : `${imageRoot}/star.png`;
        } else {
            starSrc = _isStarSelected(value) ? `${imageRoot}/star-selected.png` : `${imageRoot}/star.png`;
        }
        return starSrc;
    }

    const _isStarSelected = (value) => {
        return value <= widget.values.stars;
    };
}